/* eslint-disable no-underscore-dangle */
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';
import { getUserData } from 'services/indexcServices';

import { cleanupIndecxNpsWidget } from './cleanupIndecxWidget';

const INDECX_WIDGET_KEY = '5e46926028a0ef00ed5fc759';
const INDECX_WIDGET_ACTION = '6172ebb48f0e965f45af7db5';
const SCRIPT_ID = 'indecx-widget-js';
const WIDGET_SCRIPT_URL =
  'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js';

const Pesquisa = () => {
  const isMobile = useMediaQuery({ maxWidth: 620 });
  const { pathname } = useLocation();
  const isPortal = pathname === '/portal';

  const [userData, setUserData] = useState(null);
  const [userDataReady, setUserDataReady] = useState(false);
  const activeRef = useRef(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getUserData();
        if (data) {
          setUserData(data);
        }
      } finally {
        setUserDataReady(true);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (!isPortal) {
      activeRef.current = false;
      cleanupIndecxNpsWidget();
      return undefined;
    }

    activeRef.current = true;

    const widgetContainerId = 'indecx-widget-container';
    const widgetMinimizedId = 'indecx-widget-minimized';

    const adjustWidgetPosition = () => {
      const widget = document.getElementById(widgetContainerId);
      const mini = document.getElementById(widgetMinimizedId);
      const right = isMobile ? '100px' : '150px';

      if (widget) widget.style.setProperty('right', right);
      if (mini) mini.style.setProperty('right', right, 'important');
    };

    const loadWidget = () => {
      if (!activeRef.current || !isPortal) return;

      cleanupIndecxNpsWidget();
      activeRef.current = true;

      const firstAddress = userData?.customerAddresses?.[0];
      const phoneContact = firstAddress?.contacts?.find(
        (c) => c.contactType === 'CELL' || c.contactType === 'PHONE'
      );
      const emailContact = firstAddress?.contacts?.find(
        (c) => c.contactType === 'EMAIL'
      );

      const config = {
        key: INDECX_WIDGET_KEY,
        action: INDECX_WIDGET_ACTION,
        name:
          userData?.corporateName ||
          localStorage.getItem('@UltragazEmpresarial:customerName') ||
          '',
        email:
          userData?.email ||
          emailContact?.contact ||
          localStorage.getItem('@UltragazEmpresarial:loginEmail') ||
          '',
        phone:
          phoneContact?.contact ||
          (userData?.phoneDdd && userData?.phoneNumber
            ? `${userData.phoneDdd}${userData.phoneNumber}`
            : '') ||
          localStorage.getItem('@UltragazEmpresarial:phone') ||
          '',
        indicators: {
          cpf_cnpj:
            userData?.document ||
            localStorage.getItem('@UltragazEmpresarial:document') ||
            'CPF_INFO',
          codCliente:
            userData?.customerCode ||
            localStorage.getItem('@UltragazEmpresarial:customerCode') ||
            'COD_CLIENTE',
          codEndereco:
            userData?.customerSiteId ||
            firstAddress?.siteId ||
            localStorage.getItem('@UltragazEmpresarial:customerSiteId') ||
            'COD_ENDERECO',
          estado:
            firstAddress?.stateCode ||
            localStorage.getItem('@UltragazEmpresarial:estado') ||
            'ESTADO',
          cidade:
            firstAddress?.city ||
            localStorage.getItem('@UltragazEmpresarial:cidade') ||
            'CIDADE',
        },
      };

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = WIDGET_SCRIPT_URL;
      script.async = true;

      script.onload = () => {
        if (!activeRef.current) {
          cleanupIndecxNpsWidget();
          return;
        }

        const { IndeCX } = window;
        if (IndeCX) {
          IndeCX(config);
          window.__INDECX_WIDGET_LOADED__ = true;
          setTimeout(adjustWidgetPosition, 500);
        }
      };

      document.body.appendChild(script);
    };

    if (userDataReady) {
      loadWidget();
    }

    return () => {
      activeRef.current = false;
      cleanupIndecxNpsWidget();
    };
  }, [isMobile, userData, userDataReady, isPortal]);

  return null;
};

export default Pesquisa;
